module.exports = __webpack_public_path__ + "static/media/background.e6498a5a.jpeg";